// extracted by mini-css-extract-plugin
export var frame = "Frame-module--frame--47VIx";